import styled from 'styled-components';
import Link from '@mlb/react-patterns/components/Link/link';
import Table from '@mlb/react-patterns/components/Table/table';
import { StyledTableCell, StyledTableHead } from '@mlb/react-patterns/components/Table/TableCell/table-cell.style';

export const TeamTableWrapper = styled.div.attrs({
    'data-mlb-test': 'gamedayBoxscoreTeamTable'
})`
    margin-top: 18px;
    &.away-r1,
    &.home-r1 {
        margin-top: 0;
    }
`;

export const TeamTable = styled(Table)`
    font-feature-settings: "tnum";
    font-variant-numeric: tabular-nums lining-nums;
    border-spacing: 0px;
    border-collapse: separate;
    max-width: 100%;
    overscroll-behavior: none auto;
    &.bench{
        thead {
            th {
                padding: 12px 6px;
                min-width: 12px;
            }
        }
        tbody{
            ${StyledTableCell} {
                padding: 12px 6px;
            }
        }
    }

    &.pitchers, &.batters {
        tbody {
            tr {
                &:last-child {
                    ${StyledTableCell} {
                        font-weight: 700;
                    }
                }
            }
        }

    }
    thead {
        th {
            font-size: 12px;
            font-weight: 700;
            color: var(--gameday-primary-font-color);
            line-height: 12px;
            padding: 12px 0px;
            text-transform: capitalize;
            border-bottom: 1px solid var(--gameday-divider-color);
            &:first-child{
                text-align: left;
                padding-left: 0;
                padding-right:0;
                top: 0px;
            }
            &:not(:first-child) {
                color: var(--gameday-boxscore-thead-color);
            }
            &:last-child {
                padding-right: 0;
            }
        }
    }


    tbody {
        &:before {
            height: 12px;
        }

        tr {
            th {
                background: transparent;
            }

            &[data-selected='true'] {
                background: var(--gameday-table-active-cell-color);
                th {
                    background: var(--gameday-table-active-cell-color);
                }
                td {
                    &:first-child {
                        border-top-left-radius: 4px;
                        border-bottom-left-radius: 4px;
                    }
                    &:last-child {
                        border-bottom-right-radius: 4px;
                        border-top-right-radius: 4px;
                    }
                }
            }
        }

        ${StyledTableHead} {
            font-size: 12px;
            line-height: 12px;
            padding: 12px 0px;
            font-weight: normal;
            border-radius: 0;
            &:first-child{
                padding-left:0;
            }
        }

        ${StyledTableCell} {
            font-size: 12px;
            line-height: 12px;
            padding-top: 12px;
            padding-left:0;
            padding-bottom: 12px;
            padding-right: 0;
            font-weight: 500;
            border-radius: 0;
            color: var(--gameday-boxscore-tbody-color);
            &:first-child{
                padding-left:0;
            }
            &:not(:first-child){
                text-align: center;
            }
        }
    }
`;

export const CustomPlayerCellContainer = styled.div.attrs({
    'data-mlb-test': 'boxscorePlayerCellContainer'
})`
    min-height: 12px;
`;

export const InnerWrapper = styled.span`
    color: var(--gameday-primary-font-color);
    vertical-align: top;
`;

export const SubstitutePlayerWrapper = styled(InnerWrapper)`
    margin-left: 8px;
`;

export const PositionWrapper = styled(InnerWrapper).attrs({
    'data-mlb-test': 'boxscoreTeamTablePlayerPosition'
})`
    margin: 1px 0 0 5px;
    font-weight: 500;
    vertical-align: bottom;
    color: var(--gameday-secondary-font-color);
    font-size: 11px;
    line-height: 11px;
`;

export const PitcherWrapper = styled.span`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-right:  ${({ $enableRightPadding }) => $enableRightPadding ? '6px' : '0'};
`;

export const DecisionWrapper = styled(InnerWrapper).attrs({
    'data-mlb-test': 'boxscoreTeamTablePitchingDecision'
})`
    color: var(--gameday-secondary-font-color);
    font-weight: 500;
    font-size: 11px;
    line-height: 11px;
    white-space: nowrap;
    display: inline-block;
`;

export const PlayerLink = styled(Link).attrs({
    'data-mlb-test': 'boxscoreTeamTablePlayerNameContainer'
})`
    text-decoration:none;
    color: var(--gameday-boxscore-player-link-color) !important;
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    margin-bottom: 0px;
    vertical-align: bottom;
    &.pitcherLink {
        white-space: initial;
    }
`;

export const PlayerNameWithNoteWrapper = styled.span`
    font-weight: 700;
`;